<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<div>
						<el-button type="primary" @click="toCheckinSend()">
							下发
						</el-button>
						<el-button type="info" @click="refreshCheckin()">
							刷新签到
						</el-button>
					</div>
				</div>
			</template>
			<el-table :data="listData" :default-sort="{prop: 'date', order: 'descending'}"
				@selection-change="tableSelected" @sort-change="sortChange" border ref="userlistTable" stripe
				style="width: 100%">

				<el-table-column label="ID" prop="id" width="80"></el-table-column>
				<el-table-column label="设备IMEI" prop="imei" width="300">
					<template #default="scope">
						<el-tooltip :content="scope.row.imei" placement="top" v-if="scope.row.imei && scope.row.imei.length > 30">
							<span>{{ scope.row.imei.substring(0, 30) + '...' }}</span>
						</el-tooltip>
						<span v-else>{{ scope.row.imei }}</span>
					</template>
				</el-table-column>
				<el-table-column label="签到设备" prop="result" width="200">
					<template #default="scope">
						<el-tooltip :content="scope.row.result" placement="top" v-if="scope.row.result && scope.row.result.length > 20">
							<span>{{ scope.row.result.substring(0, 20) + '...' }}</span>
						</el-tooltip>
						<span v-else>{{ scope.row.result || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('device.creation_time')" prop="create_at" width="180"></el-table-column>
				<el-table-column label="下发状态" prop="is_send_text" width="120"></el-table-column>
				<el-table-column label="更新时间" prop="update_at" width="180"></el-table-column>
				<el-table-column label="操作" width="180">
					<template #default="scope">
						<el-button type="primary" size="small" @click="showResult(scope.row)">查看</el-button>
						<el-button v-if="scope.row.is_stop != 1" type="danger" size="small" @click="stopCheckin(scope.row.id)">停止签到</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20, 50]" :total="pageTotal"
				@current-change="handleCurrentChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</el-card>

		<el-dialog :title="'签到结果'" v-model="resultDialogVisible" width="500px">
			<el-table :data="resultList" border style="width: 100%">
				<el-table-column label="姓名/IMEI" prop="name"></el-table-column>
				<el-table-column label="设备IMEI" prop="imei"></el-table-column>
				<el-table-column label="签到时间" prop="time"></el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
	import device from "@/model/device";

	export default {
		name: "checkinList",
		data() {
			return {
				pageTotal: 0,
				formInline: {
					imei: "",
					keyword: "",
					page: 1,
					size: 10
				},
				listData: [],
				orderParam: {
					prop: "",
					order: ""
				},
				resultDialogVisible: false,
				resultList: []
			};
		},
		async mounted() {
			await this.checkinList();
		},

		methods: {
			async checkinList() {
				const ret = await device.checkinList(this.formInline);
				if (ret.code === 200) {
					this.listData = ret.data.list;
					this.pageTotal = ret.data.count;
				}
			},
			searchCont() {
				this.checkinList();
			},
			resetBtn() {
				this.$refs.searchform.resetFields();
				this.checkinList();
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.checkinList();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.checkinList();
			},
			toCheckinSend() {
				this.$router.push({
					path: "/device/checkin"
				});
			},
			refreshCheckin() {
				this.formInline.page = 1;
				this.checkinList();
				this.$message.success('刷新签到成功');
			},
			tableSelected() {
				// 表格选择事件
			},
			sortChange(column) {
				this.orderParam.prop = column.prop;
				this.orderParam.order = column.order;
			},
			showResult(row) {
				this.resultList = row.result_list || [];
				this.resultDialogVisible = true;
			},
			async stopCheckin(id) {
				try {
					await this.$confirm('确定要停止该签到吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});
					const ret = await device.stopCheckin({ id });
					if (ret.code === 200) {
						this.$message.success('停止签到成功');
						this.checkinList();
					} else {
						this.$message.error(ret.message || '停止签到失败');
					}
				} catch (e) {
					if (e !== 'cancel') {
						this.$message.error('停止签到失败');
					}
				}
			}
		}
	};
</script>
<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}

	.demo-form-inline .el-input {
		--el-input-width: 220px;
	}

	.demo-form-inline .el-select {
		--el-select-width: 220px;
	}
</style>
